// Import packages
import React, {Component} from "react";
import {connect} from "react-redux";

// Import styles
import "../assets/styles/containerStyles/contact.scss";

// Import components
import {InputGroup} from "../components/uiElements/inputGroup";
import PageWrapper from '../components/pageContentViews/pageWrapper'
import {LinkButton} from "../components/buttons/buttons";
import {LanguageTabs} from "../components/uiElements/Tabs";

// Import utils
import {mapStateToProps} from "../redux/mapStateToProps";
import {GetContact, UpdateContact} from "../redux/actions";
import {ContactAddingList} from "../constants/contactAddingList";
import {
    changeStateField,
    getInputValues,
    initTranslations,
    getTranslatableInputValues, getTranslationData, toggleStateField
} from "../utils/helperFunctions";
import {validateTranslations} from "../utils/validateTranslations";
import MediaSelectorModal from "../components/media/MediaSelectorModal";
import {isEmail} from "validator";


export class Contact extends Component {
    constructor(props) {
        super(props);
        this.translationsFields = [
            'address1',
            'address2',
            'presentationFile',
            'presentationFile2',
        ]
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields, props.activeLanguages),
                email: "",
                latitude: 0,
                longitude: 0,
                phone1: "",
                phone2: "",
                phone3: "",
            },
            isEditing: true,
            errorsTabs: [],
            errors: {},
            languageTab: props.mainLanguage,
            mediaModalOpen: false,
        };
        this.errorsSet = new Set();
        this.errorsTabs = new Set();
        this.updatedDataMap = new Map();
        this.toggleMediaModal = toggleStateField.bind(this, 'mediaModalOpen');
        this.togglePresentationFileModal = toggleStateField.bind(this, 'presentationFileModalOpen');
        this.togglePresentationFile2Modal = toggleStateField.bind(this, 'presentationFile2ModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getTranslatableInputValues = getTranslatableInputValues.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.getPresentationFile = this.getPresentationFile.bind(this);
        this.getPresentationFile2 = this.getPresentationFile2.bind(this);
        this.updateContact = this.updateContact.bind(this);
    }


    async componentDidMount() {
        !this.props?.contactData?.id && await this.props.GetContact();
        const {contactData} = this.props;
        const {fieldsData} = this.state;

        const translationsData = {};
        Object.keys(fieldsData.translations).forEach(key => {
            const trItem = contactData?.translations?.find(item => item.languageId === key);
            translationsData[key] = {
                ...fieldsData.translations[key],
                address1: trItem?.address1 || '',
                address2: trItem?.address2 || '',

            };
        });
        contactData && this.setState({
            fieldsData: {
                email: contactData.email || "",
                latitude: contactData?.location?.latitude || "",
                longitude: contactData?.location?.longitude || "",
                translations: translationsData,
                phone1: contactData?.phoneNumbers?.[0],
                phone2: contactData?.phoneNumbers?.[1],
                phone3: contactData?.phoneNumbers?.[2],
            },
        });
    }

    getPresentationFile(pdf) {
        const {fieldsData,languageTab} = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                translations: {
                    ...fieldsData.translations,
                    [languageTab]: {
                        ...fieldsData.translations[languageTab],
                        presentationFile: pdf[0],
                    }
                }
            },
        })
    }
    getPresentationFile2(pdf) {
        const {fieldsData,languageTab} = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                translations: {
                    ...fieldsData.translations,
                    [languageTab]: {
                        ...fieldsData.translations[languageTab],
                        presentationFile2: pdf[0],
                    }
                }
            },
        })
    }


    validateFields(constacData) {
        const translationRequiredFields = ['address1', 'address2'];
        const validationTr = validateTranslations(constacData.translations, translationRequiredFields);
        let result = validationTr.result;
        const errors = {...validationTr.errors};
        if (!constacData.email || !isEmail(constacData.email)) {
            result = false;
            errors.email = true;
        }
        if (!result) {
            this.setState({
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
        return result;
    }

    updateContact() {
        const {fieldsData} = this.state;
        const {translations, phone1, phone2, phone3} = fieldsData;
        if (this.validateFields(fieldsData)) {
            let TR_data = getTranslationData(translations);
            let reqData = {
                email: fieldsData.email,
                location: {
                    latitude: fieldsData?.latitude || 0,
                    longitude: fieldsData?.longitude || 0,
                },
                translations: TR_data,
                phoneNumbers: [
                    phone1 || "",
                    phone2 || "",
                    phone3 || "",
                ]
            };
            this.props.UpdateContact(reqData).then(() => {
                this.updatedDataMap.clear();
                this.setState({
                    errors: {},
                    errorsTabs: []
                })
            })
        }
    }

    render() {
        const {requestLoading, contactData: contact} = this.props;
        const {fieldsData, languageTab, errors, errorsTabs,presentationFileModalOpen,presentationFile2ModalOpen} = this.state;

        const {translations} = fieldsData;
        const initTranslations = contact?.translations?.find(lg => lg.languageId === languageTab) || {};

        const trData = translations[languageTab] || {};
        return <PageWrapper pageTitle={'Կապ'}>
            <section className="contact">

                <div className="left-part">
                    <InputGroup inputType="input"
                                type="text"
                                label="Լայնություն"
                                placeholder="Լայնություն"
                                regExp={/^[0-9]*(\.)?[0-9]*$/}
                                maxValue={90}
                                minValue={-90}
                                name="latitude"
                                value={fieldsData?.latitude}
                                error={errors['latitude']}
                                onChange={this.getInputValues}/>
                    <InputGroup inputType="input"
                                type="text"
                                label="Երկայնություն"
                                placeholder="Երկայնություն"
                                regExp={/^[0-9]*(\.)?[0-9]*$/}
                                maxValue={180}
                                minValue={-180}
                                name="longitude"
                                value={fieldsData?.longitude}
                                error={errors['longitude']}
                                onChange={this.getInputValues}/>
                </div>
                <div className="info-adding-fields">
                    <InputGroup
                        label={"Էլ․ հասցե"}
                        inputType={'input'}
                        type={'text'}
                        placeholder={"Էլ․ հասցե"}
                        name={'email'}
                        maxLength={50}
                        error={errors.email}
                        required={true}
                        value={fieldsData?.email}
                        initValue={contact?.email}
                        onChange={this.getInputValues}/>
                    <div className="social-links">
                        {/*<label>Հեռ. համարներ</label>*/}
                        {ContactAddingList.map((item, index) => {
                            return <InputGroup key={index}
                                               {...item}
                                               error={errors[item.name]}
                                               value={fieldsData?.[item.name]}
                                               initValue={contact?.[item.name]}
                                               onChange={this.getInputValues}/>
                        })}
                    </div>
                </div>
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>

                <div className={'pdf_wrapper'}>
                    <div className={'pdf_block'}>
                        <div className={'label-and-action'}>
                            <label>Կցել Presentation File</label>
                            <LinkButton className={"media-select-btn bg-white"}
                                        title={"Ընտրել PDF ֆայլ"}
                                        cb={this.togglePresentationFileModal}/>
                        </div>
                        <div className={'contract-wrapper'}>
                            <div className={'wrapper'}>
                                <span>Անվանում՝ {fieldsData.translations[languageTab]?.presentationFile?.name || initTranslations?.presentationFile?.name}</span>
                            </div>
                        </div>
                    </div>
                    <div className={'pdf_block'}>
                        <div className={'label-and-action'}>
                            <label>Կցել Presentation File</label>
                            <LinkButton className={"media-select-btn bg-white"}
                                        title={"Ընտրել PDF ֆայլ"}
                                        cb={this.togglePresentationFile2Modal}/>
                        </div>
                        <div className={'contract-wrapper'}>
                            <div className={'wrapper'}>
                                <span>Անվանում՝ {fieldsData.translations[languageTab]?.presentationFile2?.name || initTranslations?.presentationFile2?.name}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <InputGroup inputType="input"
                            type="text"
                            label={'Հասցե 1'}
                            name="address1"
                            maxLength={100}
                            value={trData?.address1}
                            required={true}
                            initValue={initTranslations?.address1}
                            error={errors['address1' + languageTab]}
                            onChange={this.getTranslatableInputValues}/>
                <InputGroup inputType="input"
                            type="text"
                            label={'Հասցե 2'}
                            name="address2"
                            maxLength={100}
                            value={trData?.address2}
                            required={true}
                            initValue={initTranslations?.address2}
                            error={errors['address2' + languageTab]}
                            onChange={this.getTranslatableInputValues}/>

                <div className="flex-wrapper-right">
                    <LinkButton title="Պահպանել"
                                loading={requestLoading}
                                cb={this.updateContact}/>
                </div>
            </section>
            <MediaSelectorModal
                isOpen={!!presentationFileModalOpen}
                acceptTypes={['pdf']}
                getMedia={this.getPresentationFile}
                appendMedias={fieldsData.translations[languageTab]?.presentationFile}
                closeModal={this.togglePresentationFileModal}
            />
            <MediaSelectorModal
                isOpen={!!presentationFile2ModalOpen}
                acceptTypes={['pdf']}
                getMedia={this.getPresentationFile2}
                appendMedias={fieldsData.translations[languageTab]?.presentationFile2}
                closeModal={this.togglePresentationFile2Modal}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    GetContact,
    UpdateContact,
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
